<template>
    <ul class="filters-pane-list">
        <li
            v-for="filter in items"
            :key="filter.name"
            class="filters-pane-list__item typographies-paragraph-medium-regular"
            :class="itemClass(filter)"
            @click="$emit('change', filter)"
        >
            <Badge v-if="isCustom" dot inline tooltip :badges="getBadges(filter)">
                {{ getItemContent(filter) }}
            </Badge>
            <span v-else class="typographies-paragraph-medium-regular">
                {{ getItemContent(filter) }}
            </span>

            <span
                v-if="filter.keywords"
                class="filters-pane-list__item-caption typographies-paragraph-small-regular"
            >
                {{ filter.keywords }}
            </span>
        </li>
    </ul>
</template>
<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';
import Badge from 'vcomponents/utilities/Badge.vue';

export default {
    components: {
        Badge,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        isCustom: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        itemClass(item) {
            return {
                'filters-pane-list__item--is-active': item.active,
            };
        },
        getItemContent(item) {
            return typeof item.label === 'object' || typeof item.label === 'array'
                ? item.label[0]
                : item.label;
        },
        getBadges({ more }) {
            const relationTypes = more ? more.useOn : [];

            return Object.entries(TagHumansConfig)
                .map(([id, tag]) => ({ id, ...tag }))
                .filter(({ id }) => relationTypes.includes(id));
        },
    },
};
</script>
<style lang="scss" scoped>
.filters-pane-list {
    margin: 0;

    &__item {
        border-radius: var(--spacing-0);
        color: var(--colors-common-text-subtle-default);
        cursor: pointer;
        padding: var(--spacing-0);

        &:hover {
            background: var(--colors-common-background-hover);
            color: var(--colors-common-text-subtle-hover);
        }

        &--is-active {
            cursor: default;
        }

        &-caption {
            color: var(--colors-common-text-standard-caption);
            display: block;
            margin: -4px 0 0;
        }
    }
}
</style>
